<template lang="pug">
  .intro_video
    .video
      video(autoplay="autoplay" muted="muted" playsinline loop data-object-fit="cover" ref="video" :src="videoSrc")
    img.top_text(src="@/assets/img/intro_video_text_top.png" alt="")
    img.bottom_text(src="@/assets/img/intro_video_text_bottom.png" alt="")
    //.next_screen(v-if="isMobileDevice" @click="$router.push({path:'/', hash:'history'})" ref="next_screen") Перейти к истории
    //.flipping(v-if="!isMobileDevice" @click="$router.push({path:'/', hash:'history'})" data-hover) листайте
        img(src="@/assets/img/flipping_icon.png" alt="")
    .bottom(ref="bottom")
      a.btn.red(href="https://www.next75.ru/" target="_blank" data-hover) Конференция NEXT 75
      //a.btn.white(href="https://homo-science.ru/" target="_blank" data-hover) СЕССИЯ ОБЩЕГО СОБРАНИЯ РАН
      a.btn.white(href="https://calendar.atom75.ru/" target="_blank" data-hover) смотреть календарь событий
</template>

<script>
export default {
  name: "IntroVideo",
  data: () => ({
    videoSrc: '',
  }),
  computed: {
    isMobileDevice() {
      return this.$store.state.isMobileDevice
    },
    deviceHeight() {
      return this.$store.state.deviceHeight
    },
  },
  mounted() {
    setTimeout(() => {
      this.videoSrc = require('@/assets/video/intro_video.mp4')
    }, 500)
    objectFitPolyfill(); // for IE, Edge
    if (this.isMobileDevice) {
      let btn = this.$refs.bottom;
      btn.style.top = this.deviceHeight - btn.offsetHeight - this.deviceHeight * 0.06 + 'px'
      window.addEventListener('orientationchange', () => {
        setTimeout(() => {
          this.$store.state.deviceHeight = document.documentElement.clientHeight;
          btn.style.top = this.deviceHeight - btn.offsetHeight - this.deviceHeight * 0.06 + 'px'
        }, 50)
      })
    }
  }
}
</script>


<style scoped lang="scss">
@import "@/assets/scss/_functions.scss";
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/_mixins.scss";

.intro_video {
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  .video {
    height: 100%;
    background: #000;
  }

  video {
    width: 100vw;
    height: 100%;
    object-fit: cover;
    opacity: 0.5;
    @include portrait {
      width: initial;
      height: 100vh;
    }
  }

  .top_text, .bottom_text {
    position: absolute;
  }

  .top_text {
    top: 24vh;
    right: 4.7vw;
    width: 21vw;
  }

  .bottom_text {
    left: 1.5vw;
    bottom: 3vh;
    width: 51.4vw;
  }

  .next_screen {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    text-transform: uppercase;
    font-family: Pobeda, Arial;
    font-size: 5.2vmin;
    font-weight: bold;
    color: #fff;
    padding: 2.4vmin 13vmin 2.5vmin 13vmin;
    white-space: nowrap;
    letter-spacing: 1px;

    &:before {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: -22%;
      z-index: -1;
      background: url(../../assets/img/nav_concurs_bg.png) no-repeat center center / 100% 100%;
    }
  }

  .flipping {
    position: absolute;
    bottom: 4vh;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 1rem;
    font-weight: bold;
    color: #fff;
    cursor: pointer;

    img {
      margin-top: 0.5vh;
      width: 1rem;
    }
  }

  .bottom {
    position: absolute;
    bottom: 6rem;
    left: 50%;
    transform: translateX(calc(-50% - 3rem));
    display: flex;
    justify-content: center;

    .btn {
      /*position: relative;
      margin: 0 2.5rem;
      width: 21.2rem;
      height: 3.25rem;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 1.25rem;
      text-transform: uppercase;
      transform: translateZ(0);
      cursor: pointer;
      &:before{
          content: '';
          display: block;
          position: absolute;
          top: 0;
          z-index: -1;
      }
      &.white:before{
          left: 0;
          right: 0;
          bottom: 0;
          transform: skewX(-14deg);
          background: #0054bf;
      }
      &.light_blue:before{
          left: 0;
          right: 0;
          bottom: 0;
          transform: skewX(-14deg);
          background: #00bcf0;
      }
      &.red:before{
          left: 0;
          right: 0;
          bottom: 0;
          transform: skewX(-14deg);
          background: #ff1c07;
      }*/
      position: relative;
      margin: 0 3rem;
      width: 21.2rem;
      height: 3.25rem;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 1.25rem;
      text-transform: uppercase;
      transform: translateZ(0);
      cursor: pointer;

      &:before {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        z-index: -1;
      }

      &.white:before {
        left: 0;
        right: 0;
        bottom: 0;
        border: to_rem(5px) solid #fff;
        transform: skewX(-14deg);
      }

      &.red:before {
        bottom: -22%;
        left: -8%;
        right: -10%;
        background: url(../../assets/img/nav_concurs_bg.png) no-repeat center center / 100% 100%;
      }
    }
  }

}

.mobile .intro_video {
  .video {
    position: relative;
    z-index: 0;

    &:before, &:after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    &:before {
      z-index: 1;
      background: url(../../assets/img/intro_video_bottom-mobile.png) no-repeat center bottom / 100% auto;
    }

    &:after {
      background: rgba($blue, 0.55);
    }
  }

  .top_text, .bottom_text {
    display: none;
  }

  .top_text {
    top: 17vh;
    right: -3vmin;
    width: 44vmin;
  }

  .bottom_text {
    left: -2.5vmin;
    bottom: 21vh;
    width: 89.4vmin;
  }

  .bottom {
    bottom: auto;
    flex-direction: column;
    justify-content: initial;
    align-items: center;
    flex-shrink: 0;
    transform: translateX(-50%);

    /*.btn {
      width: 58vmin;
      min-height: 9vmin;
      height: auto;
      margin: 0;
      font-size: 4vmin;

      &.red {
        margin-bottom: 6vmin;
      }

      &.white {
        margin-bottom: 6vmin;

        &:before {
          border: to_rem(5px) solid #fff;
        }
      }
    }*/
    .btn{
      width: 58vmin;
      min-height: 9vmin;
      height: auto;
      margin: 0;
      font-size: 4vmin;
      &.red{
        margin-bottom: 5vmin;
      }
    }
  }
}
</style>
